import { SVGProps } from "react";

const ArrowDiagonalRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width ? props.width : "14"}
    height={props.height ? props.height : "14"}
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.75 1.75L0.75 12.75"
      stroke={props.stroke || "white"}
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M5.75 0.881514C5.75 0.881514 11.3835 0.40662 12.2385 1.26153C13.0934 2.11645 12.6184 7.75 12.6184 7.75"
      stroke={props.color || "white"}
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
      fill={props.fill}
    />
  </svg>
);
export default ArrowDiagonalRight;
